<p1-lib-ui-elements-modal *ngIf="show"
                          [closeable]="true"
                          (closeModal)="closeDialog()">
  <ng-container modal-header>
    <h2 i18n="copy watchlist dialog headline // page: watchlistSnapshots/{uuid} @@copy-watchlist-dialog.component_headline">
      Copy watchlist
    </h2>
  </ng-container>

  <ng-container modal-content>
    <p i18n="copy watchlist dialog description // page: watchlistSnapshots/{uuid} @@copy-watchlist-dialog.component_description">
      Add a copy of this list to your own set of watchlists.
    </p>
    <form class="frm"
          [formGroup]="watchlistFormGroup"
          (submit)="submitWatchlist()">
      <input label="Name of the copy"
             class="frm__field--input--text"
             formControlName="name"
             [ngClass]="{'frm__field--input--text--error': this.watchlistFormGroup.get('name').hasError('notUniqueName')}"
             i18n-label="copy watchlist name input label // page: watchlistSnapshots/{uuid} @@copy-watchlist-dialog.component_input_label">
      <p *ngIf="this.watchlistFormGroup.get('name').hasError('notUniqueName')"
         class="frm__field frm__field__hint frm__field__hint--error"
         i18n="invalid-hint for watchlist name input // page: watchlistSnapshots/{uuid} @@copy-watchlist-dialog.component_name-invalid">
        A watchlist with this name already exists. Please choose a different name.
      </p>
    </form>
  </ng-container>

  <ng-container modal-actions>
    <div class="cta-area__row">
      <div class="cta-area__left">
        <button p1Button
                buttonType="secondary"
                (click)="closeDialog()"
                i18n="copy watchlist dialog abort button // page: watchlistSnapshots/{uuid} @@copy-watchlist-dialog.component_abort_button">
          Cancel
        </button>
      </div>
      <div class="cta-area__right">
        <p1-lib-ui-elements-button-loading [loading]="copyWatchlistInProgress"
                                           [disabled]="watchlistFormGroup.invalid"
                                           (buttonClick)="submitWatchlist()"
                                           i18n="copy watchlist dialog copy button // page: watchlistSnapshots/{uuid} @@copy-watchlist-dialog.component_copy_button">
          Copy
        </p1-lib-ui-elements-button-loading>
      </div>
    </div>
  </ng-container>
</p1-lib-ui-elements-modal>
